import { render, staticRenderFns } from "./IrWalletTrans.vue?vue&type=template&id=e8f930c4"
import script from "./IrWalletTrans.vue?vue&type=script&lang=js"
export * from "./IrWalletTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports